import { DocumentationPage } from './_article.jsx';
export default function PodcastSitesAndDomainsPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}